import moment from "moment";

export default {
    computed: {
        now() {
            return moment().format("YYYY-MM-DD");
        },
    },

    methods: {
        stripYears(date) {
            return date.substring(5);
        },

        formatDate(date) {
            return moment(date).format('DD-MM-YYYY HH:mm');
        }
    },
};